import React from 'react';
import SvgMenuPecosSmall from '@components/icons/admin/MenuPecosSmall.tsx';
import SvgMenuAnchorLocked from '@components/icons/admin/MenuAnchorLocked.tsx';
import SvgMenuAnchor from '@components/icons/admin/MenuAnchor.tsx';
import { IconWrapper } from '@components/icons/IconWrapper.tsx';

interface ComponentProps {
  smallMenu: boolean;
  lockedMenu: boolean;
  setLockedMenu: (value: boolean) => void;
  /** Menu je vysunuty panel (tablet/telefon) — misto zamku se ukaze krizek pro zavreni. */
  onClose?: () => void;
}

const MenuHeader: React.FC<ComponentProps> = ({ smallMenu, lockedMenu, setLockedMenu, onClose }) => {
  if (onClose) {
    return (
      <div className={'p-4 bg-surface-dark-primary flex justify-between h-[72px] items-center'}>
        <IconWrapper className={'h-8 w-8 text-white'}>
          <SvgMenuPecosSmall />
        </IconWrapper>
        <button type="button" aria-label="Zavřít menu" onClick={onClose} className={'p-2 -mr-2 text-white'}>
          <svg viewBox="0 0 24 24" className={'h-6 w-6'} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </div>
    );
  }

  return (
    <>
      {smallMenu && !lockedMenu ? (
        <>
          <div className={'p-4 bg-surface-dark-primary flex justify-center h-[72px] items-center'}>
            <IconWrapper className={'h-8 w-8 text-white'}>
              <SvgMenuPecosSmall />
            </IconWrapper>
          </div>
        </>
      ) : (
        <div className={'p-4 bg-surface-dark-primary flex justify-between h-[72px] items-center'}>
          <IconWrapper className={'h-8 w-8 text-white'}>
            <SvgMenuPecosSmall />
          </IconWrapper>
          <IconWrapper className={'h-5 w-5 text-white'}>
            {lockedMenu ? <SvgMenuAnchorLocked onClick={() => setLockedMenu(false)} /> : <SvgMenuAnchor onClick={() => setLockedMenu(true)} />}
          </IconWrapper>
        </div>
      )}
    </>
  );
};

export default MenuHeader;
